// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1POin","fileDisabled":"File_fileDisabled__UBrcD"};